import { Props } from './props';
import { useStyles } from './styles';

export const Space: React.FC<Props> = ({ children, ...props }) => {
  const styles = useStyles(props);
  return <div className={styles.root}>{children}</div>;
};
